<template>
	<o-tour :ref="setup._tourQrCode">
		<o-tour-step
			title="Bienvenue dans la liste de vos sociétés"
			hide-finish>
			<p>
				C'est ici, dans la liste de vos sociétés que vous pourrez trouver vos
				QR Code agences !
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="setup.hasData"
			target="qr-code-icon"
			:next="setup.showQrIconOnHover()"
			hide-finish>
			<p>
				Soit en cliquant sur cette icone
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="setup.hasData"
			:end="setup.removeHover()"
			target="qr-code">
			Ou là
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import TourQrCodeSetupService from '@/setup/tour/TourQrCodeSetupService';
const setup = new TourQrCodeSetupService();
</script>
